import{b as e}from"./chunk-LSZKOVGW.mjs";import{j as o,k as r}from"./chunk-SGUETU3K.mjs";var f=new o({locale:[e,r]});export{f as a};
